$(() => {
  const click = event => {
    const link = $(event.target).closest(':has(a)').find('a')
    link.click()
  }
  $(document).on('click', '.stretched-inner-link', click)
})
